import { createAsyncThunk } from '@reduxjs/toolkit';

import { postDataApi } from '../../api/methods';

export const fetchReports = createAsyncThunk(
    'admin/report',
    (payload: any) => postDataApi({ path: 'admin/report', data: payload })
);
